import { render, staticRenderFns } from "./MitActionsNewPersonWizard.vue?vue&type=template&id=49074289&scoped=true"
import script from "./MitActionsNewPersonWizard.vue?vue&type=script&lang=js"
export * from "./MitActionsNewPersonWizard.vue?vue&type=script&lang=js"
import style0 from "./MitActionsNewPersonWizard.vue?vue&type=style&index=0&id=49074289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49074289",
  null
  
)

export default component.exports